export const PREVIEW_SUBTITLE = "本學年，前 30 名";

const DURATION_NOUN = {
  member: "學生",
  school_cls: "班別",
  grp: "社",
  organization: "學校",
};

export function parseLeaderboardCode(code) {
  const parts = String(code || "").split("/");
  if (parts.length < 5 || parts.some((part) => part.trim() === "" || part === "?")) {
    return null;
  }
  return {
    scope: parts[0],
    scopeArg: parts[1],
    groupBy: parts[2],
    item: parts[3],
    skillCode: parts[4],
  };
}

function scopeTitle(scope, scopeArg) {
  if (scope === "organization") {
    return "本校";
  }
  if (scope === "form" || scope === "grade") {
    return scopeArg && scopeArg !== "_" ? `${scopeArg} 級` : "";
  }
  if (scope === "grp") {
    return scopeArg && scopeArg !== "_" ? scopeArg : "";
  }
  if (scope === "steminpe") {
    return "STEM in PE 聯校";
  }
  return "";
}

function metricTitle(parsed, skillName) {
  if (parsed.item === "duration") {
    const noun = DURATION_NOUN[parsed.groupBy] || "";
    return noun ? `${noun}累計時長` : "累計時長";
  }
  if (parsed.item === "score") {
    const name = String(skillName || "").trim() || (parsed.skillCode !== "all" ? parsed.skillCode : "");
    return name ? `${name}最佳成績` : "最佳成績";
  }
  return "";
}

export function previewTitle(code, skillName) {
  const parsed = parseLeaderboardCode(code);
  if (!parsed) {
    return "";
  }
  return [scopeTitle(parsed.scope, parsed.scopeArg), metricTitle(parsed, skillName)].filter(Boolean).join(" • ");
}

export function previewColumnHeader(code) {
  const parsed = parseLeaderboardCode(code);
  if (!parsed) {
    return "";
  }
  if (parsed.groupBy === "member") {
    return parsed.scope === "steminpe" ? "學生 • 學校 • 班別 • 社" : "學生 • 班別 • 社";
  }
  if (parsed.groupBy === "school_cls") {
    return "班別";
  }
  if (parsed.groupBy === "grp") {
    return "社";
  }
  if (parsed.groupBy === "organization") {
    return "學校";
  }
  return "";
}

export function previewMetricHeader(code) {
  const parsed = parseLeaderboardCode(code);
  return parsed?.item === "score" ? "最佳成績" : "累計時長";
}

function schoolLabel(row, orgId) {
  if (orgId != null && orgId !== "" && String(row?.org_id) === String(orgId)) {
    return "本校";
  }
  return String(row?.org_name_zh || "").trim();
}

export function previewRowText(code, row, orgId) {
  const parsed = parseLeaderboardCode(code);
  if (!parsed) {
    return { name: "", meta: "" };
  }

  if (parsed.groupBy === "organization") {
    return { name: schoolLabel(row, orgId), meta: "" };
  }
  if (parsed.groupBy === "school_cls") {
    return { name: String(row?.school_cls || "").trim(), meta: "" };
  }
  if (parsed.groupBy === "grp") {
    return { name: String(row?.group || "").trim(), meta: "" };
  }

  const name = String(row?.display_name || "").trim();
  const cls = String(row?.school_cls || "").trim();
  const group = String(row?.group || "").trim();
  if (parsed.scope === "steminpe") {
    return { name, meta: [schoolLabel(row, orgId), cls, group].filter(Boolean).join(" · ") };
  }
  return { name, meta: [cls, group].filter(Boolean).join(" · ") };
}

export function formatDuration(seconds) {
  const totalSeconds = Number(seconds);
  const safeSeconds = Number.isFinite(totalSeconds) ? Math.max(0, totalSeconds) : 0;
  if (safeSeconds === 0) {
    return { value: "-", unit: "" };
  }

  const minutes = safeSeconds / 60;
  if (minutes < 1) {
    return { value: "1", unit: "分鐘" };
  }
  if (minutes < 60) {
    return { value: Math.round(minutes).toLocaleString("en-US"), unit: "分鐘" };
  }

  const hours = (safeSeconds / 3600).toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
  return { value: hours, unit: "小時" };
}

function formatScore(value, unit) {
  const score = Number(value);
  if (!Number.isFinite(score)) {
    return { value: "-", unit: "" };
  }
  const text = score.toLocaleString("en-US", { maximumFractionDigits: 2 });
  return { value: text, unit: String(unit || "").trim() };
}

export function previewMetric(code, row, unit) {
  const parsed = parseLeaderboardCode(code);
  if (parsed?.item === "score") {
    return formatScore(row?.best_score, unit);
  }
  return formatDuration(row?.total_duration);
}
